import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShowcaseService } from 'src/app/services/header-showcase/showcase.service';

@Component({
    selector: 'app-internal-complaint',
    templateUrl: './internal-complaint.component.html',
    styleUrls: ['./internal-complaint.component.scss']
})
export class InternalComplaintComponent implements OnInit, OnDestroy {
    src: string = '/assets/pdf/Internal Complaint Committee.pdf';
    title: string = 'Internal Complaint Committee';

    constructor(private showcaseService: ShowcaseService) {
        this.showcaseService.hideShowcase();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.showcaseService.showingShowcase();
    }

}
